// extracted by mini-css-extract-plugin
export default {"lessonsContainer":"Lessons_lessonsContainer__Vx5Rt","header":"Lessons_header__9ebhx"};